<template>
  <div>
    <mobile-calendar-handler v-if="isMobile" />
    <calendar-handler v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MobileCalendarHandler from './MobileCalendarHandler.vue'
import CalendarHandler from './CalendarHandler.vue'

export default {
  components: {
    MobileCalendarHandler, CalendarHandler
  },
  computed: {
    ...mapState('common', ['isMobile'])
  }
}
</script>
